import { ActionButton } from 'src/sections/employer-data/shared/components/action-button';

// ----------------------------------------------------------------------

type MovePolicyButtonProps = {
  onClick: () => void;
};

export function MovePolicyButton({ onClick }: MovePolicyButtonProps) {
  return <ActionButton label="Move policy" testId="move-policy-button" onClick={onClick} />;
}
